export const FaturamentoModais = {
  modalPendenciasFaturamento: 'modalPendenciasFaturamento',
};
